import apiFetch from '../apiFetch'

export default function (token, fuelId) {
  return apiFetch({ endPoint: 'Fuel/' + fuelId, method: 'GET', token: token })
}
